module.exports = __webpack_public_path__ + "static/media/tele3.52d2516d.svg";